import TEInputRow from './TEInputRow';

export default TEInputRow;
